import { useMemo } from 'react';
import { isInternalUser, useDemoMode, useSession } from '@distribusion/portal-lib/auth';
import { useBreakpoint } from '@distribusion/portal-lib/responsive';
import { Layout, Space } from 'antd';
import classNames from 'classnames';
import { CurrencySwitch } from 'features/settings';
import { LanguageSwitch } from 'features/translation';
import { featureFlags } from 'lib/feature-flags';

import { BetaFeaturesSwitch } from '../beta-features-switch';
import { DemoIndicator } from '../demo-indicator';
import { DemoSwitch } from '../demo-switch';
import { FeatureFlagsSwitch } from '../feature-flags-switch';
import { ProfileMenu } from '../profile-menu';

import './header.less';

interface HeaderProps {
  children: React.ReactNode;
}

export const Header = ({ children }: HeaderProps) => {
  const { shouldShowDemoSwitch, demoModeEnabled } = useDemoMode();
  const { lg } = useBreakpoint();
  const { data: session } = useSession();

  const isCurrentUserInternal = useMemo(() => isInternalUser(session), [session]);

  return (
    <Layout.Header
      className={classNames('application-header', {
        'application-header--with-padding': demoModeEnabled,
      })}
    >
      {demoModeEnabled && <DemoIndicator />}
      <div className="header-content">
        <Space>{children}</Space>
        <Space size={!lg ? 0 : undefined}>
          {lg && shouldShowDemoSwitch && <DemoSwitch />}
          <CurrencySwitch />
          <LanguageSwitch />
          {featureFlags.debug && <FeatureFlagsSwitch />}
          {featureFlags.betaFeaturesForInternals && isCurrentUserInternal && <BetaFeaturesSwitch />}
          <ProfileMenu />
        </Space>
      </div>
    </Layout.Header>
  );
};
